import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const WhatsAppWidget = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const whatsappNumber = '+40743691021';
  const message = 'Hello! I\'m interested in Sheba Smart Home services.';

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <>
      {/* WhatsApp Button */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2 }}
        className="fixed bottom-6 right-6 z-50"
        data-testid="whatsapp-widget"
      >
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.8 }}
              className="glass-strong rounded-3xl p-6 mb-4 w-80 shadow-2xl"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center">
                    <FaWhatsapp className="text-white text-2xl" />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold">{t('whatsapp.chatWithUs')}</h4>
                    <div className="flex items-center space-x-1">
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                      <span className="text-white/60 text-xs">{t('whatsapp.onlineNow')}</span>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-white/60 hover:text-white transition-colors"
                >
                  <FaTimes />
                </button>
              </div>

              <p className="text-white/80 text-sm mb-4 leading-relaxed">
                {t('whatsapp.greeting')}
              </p>

              <button
                onClick={handleWhatsAppClick}
                className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-4 rounded-xl transition-colors flex items-center justify-center space-x-2"
                data-testid="whatsapp-chat-btn"
              >
                <FaWhatsapp className="text-xl" />
                <span>{t('whatsapp.startChat')}</span>
              </button>

              <p className="text-white/40 text-xs text-center mt-3">
                {t('whatsapp.typicallyReplies')}
              </p>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Main Button */}
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setIsOpen(!isOpen)}
          className="w-16 h-16 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center shadow-2xl group relative"
          data-testid="whatsapp-toggle-btn"
        >
          <FaWhatsapp className="text-white text-3xl" />
          
          {/* Pulse Animation */}
          <motion.div
            animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0, 0.5] }}
            transition={{ repeat: Infinity, duration: 2 }}
            className="absolute inset-0 rounded-full bg-green-500"
          />

          {/* Notification Badge */}
          {!isOpen && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold"
            >
              1
            </motion.div>
          )}
        </motion.button>
      </motion.div>
    </>
  );
};

export default WhatsAppWidget;